import ShaderCanvas from "../components/ShaderCanvas";
import React, { useState } from "react";

const fragShader = `
#ifdef GL_ES
precision mediump float;
#endif

#define PI 3.14159265359

uniform vec2 u_resolution;
uniform vec2 u_mouse;
uniform float u_time;

vec3 colorA = vec3(1.0,0.0,0.0);
vec3 colorB = vec3(0.0,0.0,1.0);

float lineWidth = 0.01;

float plot (vec2 st, float pct){
  return  smoothstep( pct - lineWidth, pct, st.y) -
          smoothstep( pct, pct + lineWidth, st.y);
}

void main() {
    vec2 st = gl_FragCoord.xy/u_resolution.xy;
    vec3 color = vec3(0.0);

    vec3 pct = vec3(st.x);

    pct.r = smoothstep(0.0, 1.0, st.x);
    pct.g = sin(st.x * PI);
    pct.b = pow(st.x, 4.0 + sin(u_time) * 4.0);

    color = mix(colorA, colorB, pct);

    color = mix(color,vec3(1.0,0.0,0.0),plot(st,pct.r));
    color = mix(color,vec3(0.0,1.0,0.0),plot(st,pct.g));
    color = mix(color,vec3(0.0,0.0,1.0),plot(st,pct.b));

    gl_FragColor = vec4(color,1.0);
}
`;

export default () => {
  const [live, setLive] = useState({ time: 0, resolution: [0,0], mouse: [0,0], mouseNorm: [0,0] });

  return(
    <div style = { { position: "relative", display: "flex", justifyContent: "center", gap : "16px" } }>
        <ShaderCanvas fragShader={fragShader} onFrame={(vals) => setLive(vals)} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <pre>
            {(() => {
              // create a copy and inject live values into uniform declarations
              let src = fragShader;
              // inject u_time as a comment after its declaration
              src = src.replace(/uniform\s+float\s+u_time\s*;/, `uniform float u_time; // ${live.time.toFixed(1)}`);
              // inject u_resolution
              src = src.replace(/uniform\s+vec2\s+u_resolution\s*;/, `uniform vec2 u_resolution; // ${live.resolution[0]} x ${live.resolution[1]}`);
              // inject u_mouse (show normalized values which are now passed as u_mouse)
              src = src.replace(/uniform\s+vec2\s+u_mouse\s*;/, `uniform vec2 u_mouse; // ${live.mouseNorm[0].toFixed(1)} , ${live.mouseNorm[1].toFixed(1)}`);
              return src;
            })()}
          </pre>
        </div>
    </div>
  );
}